import { useState, useCallback } from "react";

export interface GoalStore {
  target: number;
}

export function getWeekStartMs(): number {
  const d = new Date();
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(d.getFullYear(), d.getMonth(), diff);
  monday.setHours(0, 0, 0, 0);
  return monday.getTime();
}

const DEFAULT: GoalStore = { target: 3 };

function load(): GoalStore {
  try {
    const raw = localStorage.getItem("growseo_goal");
    if (raw) return { ...DEFAULT, ...JSON.parse(raw) };
  } catch (e) {
    console.warn("GoalStore load error", e);
  }
  return DEFAULT;
}

function save(s: GoalStore) {
  try {
    localStorage.setItem("growseo_goal", JSON.stringify(s));
  } catch (e) {
    console.warn("GoalStore save error", e);
  }
}

export function useGoalStore() {
  const [goal, setGoal] = useState<GoalStore>(load);

  const setTarget = useCallback((target: number) => {
    setGoal((prev) => {
      const next = { ...prev, target };
      save(next);
      return next;
    });
  }, []);

  return { goal, setTarget };
}
